import React, { useState, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Box, Typography, Button, Stack, Grid, Chip } from "@mui/material";
import heroBg from "../../assets/image/png/parts-hero-bg.png"; // 👈 your local image
import { fireGtagEvent } from "../../utils/gtagEvents";

const VendorLanding = () => {
    const formRef = useRef(null);

    const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid #e2e8f0",
  fontSize: 14,
  outline: "none",
};

const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  message: "",
});

const [loading, setLoading] = useState(false);

const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value.trimStart(),
  });
};

const isValidPhone = (phone) => {
  return /^[6-9]\d{9}$/.test(phone); // Indian mobile numbers
};

const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const isValidName = (name) => {
  return name.trim().length >= 2;
};


const handleSubmit = async () => {
  fireGtagEvent("qualify_lead");

  const { name, phone, email } = formData;

  if (!isValidName(name)) {
    toast.error("Please enter a valid name");
    return;
  }

  if (!isValidPhone(phone)) {
    toast.error("Please enter a valid 10-digit mobile number");
    return;
  }

  if (!isValidEmail(email)) {
    toast.error("Please enter a valid email address");
    return;
  }

  try {
    setLoading(true);

    await axios.post(
      process.env.REACT_APP_API_URL + `/parts-vendor-lead`,
      {
        ...formData,
        name: name.trim(),
        email: email.toLowerCase(),
      }
    );

    toast.success("Thank you! Our team will contact you shortly.");

    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
    });
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};



  return (
    <>
{/* ================= HERO SECTION WITH FORM ================= */}
<Box
  sx={{
    minHeight: { xs: "auto", md: "calc(90vh - 72px)" },
    pt: "72px", // 👈 critical
    pb: { xs: 6, md: 6 },
    display: "flex",
    alignItems: "center",
    backgroundImage: `linear-gradient(
      rgba(32, 26, 26, 0.55),
      rgba(32, 26, 26, 0.45)
    ), url("${heroBg}")`,
    backgroundSize: "cover",
    backgroundPosition: { xs: "center", md: "center right" },
    px: { xs: 2, sm: 3, md: 6 },
  }}
>
  <Grid
    container
    spacing={{ xs: 4, md: 6 }}
    alignItems="center"
    maxWidth="1200px"
    mx="auto"
  >
    {/* ================= LEFT CONTENT ================= */}
    <Grid item xs={12} md={6} textAlign={{ xs: "center", md: "left" }}>
  <Box
    sx={{
      bgcolor: "rgba(0, 0, 0, 0.35)", // transparent dark
      backdropFilter: "blur(8px)",   // glass effect
      borderRadius: 3,
      p: { xs: 3, sm: 4 },
      display: "inline-block",
      maxWidth: 600,
      mx: { xs: "auto", md: 0 },
      border: "1px solid rgba(255,255,255,0.15)",
    }}
  >
    <Chip
      label="FOR SPARE PARTS & COMPONENT VENDOR"
      sx={{
        bgcolor: "#ff6b35",
        color: "white",
        mb: 2,
        fontSize: 12,
        fontWeight: 600,
      }}
    />

    <Typography
      sx={{
        fontSize: { xs: 28, sm: 36, md: 48 },
        fontWeight: 700,
        color: "white",
        mb: 2,
        lineHeight: 1.2,
      }}
    >
      Sell to{" "}
      <Box component="span" sx={{ color: "#0ea5e9" }}>
        100,000+
      </Box>{" "}
      Drone <br />
      Owners Nationwide
    </Typography>

    <Typography
      sx={{
        color: "#f7f7f7",
        fontSize: { xs: 14, sm: 16 },
        mb: 3,
        maxWidth: 520,
        mx: { xs: "auto", md: 0 },
      }}
    >
      Turn your parts catalog into revenue. List once, reach hobbyists,
      professionals, and repair shops across India.
    </Typography>

    <Typography sx={{ fontSize: 13, color: "#ffffff" }}>
      ✓ 2,500+ vendors generating ₹50L+ GMV monthly
    </Typography>
  </Box>
</Grid>


    {/* ================= RIGHT FORM ================= */}
    <Grid
      item
      xs={12}
      md={6}
      display="flex"
      justifyContent={{ xs: "center", md: "flex-end" }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          bgcolor: "white",
          borderRadius: 2,
          boxShadow: "0 10px 40px rgba(15,23,42,0.25)",
          p: { xs: 3, sm: 4 },
        }}
      >
        <Typography
          fontWeight={700}
          fontSize="1.4rem"
          textAlign="center"
          mb={1}
          color="#0f172a"
        >
          Register Now
        </Typography>

        {/* <Typography
          fontSize={13}
          textAlign="center"
          color="#64748b"
          mb={3}
        >
          List your first product free. Get support within 24 hours.
        </Typography> */}

        {/* Name */}
        <Typography fontSize={13} mb={0.5}>
          Name *
        </Typography>
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your full name"
          style={inputStyle}
        />

        {/* Phone */}
        <Typography fontSize={13} mt={2} mb={0.5}>
          Phone Number *
        </Typography>
        <input
          name="phone"
          value={formData.phone}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, ""); // numbers only
            if (value.length <= 10) {
              setFormData({ ...formData, phone: value });
            }
          }}
          placeholder="XXXXXXXXXX"
          maxLength={10}
          inputMode="numeric"
          style={inputStyle}
        />


        {/* Email */}
        <Typography fontSize={13} mt={2} mb={0.5}>
          Email *
        </Typography>
        <input
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="you@example.com"
          style={inputStyle}
        />

        {/* Message */}
        <Typography fontSize={13} mt={2} mb={0.5}>
          Message
        </Typography>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows={4}
          placeholder="Tell us about your requirements"
          style={{ ...inputStyle, resize: "none" }}
        />

        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          onClick={handleSubmit}
          sx={{
            mt: 3,
            bgcolor: "#0ea5e9",
            py: 1.2,
            fontWeight: 600,
            "&:hover": { bgcolor: "#0284c7" },
          }}
        >
          {loading ? "Submitting..." : "REGISTER AS VENDOR"}
        </Button>
      </Box>
    </Grid>
  </Grid>
</Box>


      {/* ================= TRUST SECTION ================= */}
      <Box
  sx={{
    py: { xs: 6, md: 8 },
    px: { xs: 2, sm: 3 },
  }}
>
  <Typography
    variant="h4"
    textAlign="center"
    fontWeight="700"
    mb={{ xs: 4, md: 5 }}
    sx={{ color: "#0f172a" }}
  >
    Why Vendors Trust Drone Planet
  </Typography>

  {/* ✅ Centered Content Container */}
  <Box
    sx={{
      maxWidth: 1100,
      mx: "auto",
    }}
  >
    <Grid
      container
      spacing={{ xs: 3, md: 6 }}
      alignItems="flex-start"
    >
      {/* Left: Problem */}
      <Grid item xs={12} md={6}>
        <Box sx={{ pr: { md: 3 } }}>
          <Typography
            sx={{
              color: "#e11010ff",
              fontWeight: 700,
              mb: 2,
              letterSpacing: 1,
            }}
          >
            The Problem
          </Typography>

          <Stack spacing={2}>
            <Typography sx={{ color: "#334155" }}>
              • Fragmented customer base (no single discovery platform)
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Low online visibility—buried in Amazon, Alibaba noise
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Complex returns & warranty management
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Real-time inventory visibility challenges
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Competing on price alone; no brand differentiation
            </Typography>
          </Stack>
        </Box>
      </Grid>

      {/* Right: Solution */}
      <Grid item xs={12} md={6}>
        <Box sx={{ pl: { md: 3 } }}>
          <Typography
            sx={{
              color: "#0bde63ff",
              fontWeight: 700,
              mb: 2,
              letterSpacing: 1,
            }}
          >
            How we solve it
          </Typography>

          <Stack spacing={2}>
            <Typography sx={{ color: "#334155" }}>
              • Direct access to 100,000+ verified drone owners & enthusiasts
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Dedicated marketplace for niche parts (discovery 10x easier)
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Built-in warranty & dispute resolution workflows
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • AI-powered inventory sync & smart reorder suggestions
            </Typography>
            <Typography sx={{ color: "#334155" }}>
              • Reviews, ratings, and brand-building tools included
            </Typography>
          </Stack>
        </Box>
      </Grid>
    </Grid>
  </Box>
</Box>


      {/* ================= WHAT YOU GET ================= */}
<Box
  sx={{
    py: { xs: 5, md: 8 },
    px: { xs: 2, sm: 3 },
    bgcolor: "#f8fafc",
  }}
>
  <Typography
    variant="h4"
    textAlign="center"
    fontWeight="700"
    mb={{ xs: 4, md: 5 }}
    sx={{
      color: "#0f172a",
      fontSize: { xs: "1.6rem", md: "2rem" },
    }}
  >
    What You Get on Drone Planet
  </Typography>

  {/* ✅ TRUE CENTERED CONTAINER */}
  <Box
    sx={{
      maxWidth: 1100,
      mx: "auto",
    }}
  >
    <Grid
      container
      spacing={{ xs: 2, md: 3 }}
    >
      {[
        {
          title: "Niche-Focused Buyers",
          desc: "Customers actively searching for parts, not just browsing.",
        },
        {
          title: "Smart Recommendations Engine",
          desc: "AI matches products to buyer intent. Higher cart value, faster conversion.",
        },
        {
          title: "Bulk Order Routing",
          desc: "Connect directly with repair shops and businesses at scale.",
        },
        {
          title: "Low Commissions, High Volume",
          desc: "Zero setup. 12% commission only on what sells.",
        },
        {
          title: "Inventory Management",
          desc: "Real-time sync prevents overselling and stockouts.",
        },
        {
          title: "Dispute Resolution & Trust",
          desc: "Built-in warranty & return workflows. You set the policy.",
        },
      ].map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box
            sx={{
              p: { xs: 2.5, md: 3 },
              height: "100%",
              borderRadius: 2,
              bgcolor: "white",
              boxShadow: "0 8px 30px rgba(15,23,42,0.05)",
              textAlign: { xs: "center", md: "left" },
              transition: "0.3s ease",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 12px 35px rgba(15,23,42,0.08)",
              },
            }}
          >
            {/* Icon */}
            <Box
              sx={{
                width: 40,
                height: 40,
                bgcolor: "#e0f2fe",
                borderRadius: 1.5,
                mb: 2,
                mx: { xs: "auto", md: 0 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#0ea5e9",
                fontWeight: 700,
              }}
            >
              ✓
            </Box>

            <Typography
              fontWeight={700}
              mb={1}
              sx={{
                color: "#0f172a",
                fontSize: { xs: 15, md: 16 },
              }}
            >
              {item.title}
            </Typography>

            <Typography
              fontSize={14}
              sx={{
                color: "#475569",
                maxWidth: { xs: "100%", md: "90%" },
                mx: { xs: "auto", md: 0 },
              }}
            >
              {item.desc}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
</Box>




{/* ================= TRUSTED BY ================= */}
<Box
  sx={{
    py: { xs: 5, md: 8 },
    px: { xs: 2, sm: 3 },
  }}
>
  <Typography
    variant="h4"
    textAlign="center"
    fontWeight="700"
    mb={{ xs: 4, md: 5 }}
    sx={{
      color: "#0f172a",
      fontSize: { xs: "1.6rem", md: "2rem" },
    }}
  >
    Trusted by India&apos;s Top Parts Vendors
  </Typography>

  {/* ✅ TRUE CENTERED CONTAINER */}
  <Box
    sx={{
      maxWidth: 1100,
      mx: "auto",
    }}
  >
    <Grid
      container
      spacing={{ xs: 3, md: 4 }}
      textAlign="center"
    >
      {[
        {
          value: "2,500+",
          label: "Active Vendors",
          desc: "Over 2,500 drone owners have successfully sold their equipment through our platform.",
        },
        {
          value: "₹50L+",
          label: "Avg Monthly GMV",
          desc: "Total value paid out to vendors with an average payout of ₹2,00,000 per transaction.",
        },
        {
          value: "7 Days",
          label: "Avg Time to First Order",
          desc: "From evaluation to payment, our average completion time is 6–7 days.",
        },
        {
          value: "92%",
          label: "Vendor Satisfaction",
          desc: "Our vendors rate their experience highly for trust, transparency, and ease.",
        },
      ].map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Box
            sx={{
              px: { xs: 1, md: 2 },
            }}
          >
            <Typography
              fontWeight="700"
              sx={{
                color: "#0ea5e9",
                mb: 1,
                fontSize: { xs: "1.8rem", md: "2rem" },
              }}
            >
              {stat.value}
            </Typography>

            <Typography
              fontWeight={600}
              sx={{
                color: "#0f172a",
                mb: 1,
                fontSize: { xs: 14, md: 15 },
              }}
            >
              {stat.label}
            </Typography>

            <Typography
              sx={{
                color: "#475569",
                fontSize: 14,
                maxWidth: 260,
                mx: "auto",
              }}
            >
              {stat.desc}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
</Box>



{/* ================= JOIN VENDORS FORM ================= */}
<Box
  ref={formRef}
  sx={{
    py: { xs: 5, md: 8 },
    px: { xs: 2, sm: 3 },
  }}
>
  <Typography
    variant="h4"
    textAlign="center"
    fontWeight="700"
    sx={{
      color: "#0f172a",
      mb: 1,
      fontSize: { xs: "1.6rem", md: "2rem" },
    }}
  >
    Join 2,500+ Vendors
  </Typography>

  <Typography
    textAlign="center"
    sx={{
      color: "#64748b",
      mb: { xs: 4, md: 5 },
      fontSize: { xs: 13, md: 14 },
      maxWidth: 520,
      mx: "auto",
    }}
  >
    List your first product free. Get support for setup, pricing, and marketing
    within 24 hours.
  </Typography>

  <Box
    sx={{
      maxWidth: { xs: "100%", sm: 420 },
      mx: "auto",
      bgcolor: "white",
      borderRadius: 2,
      boxShadow: "0 10px 40px rgba(15,23,42,0.08)",
      p: { xs: 3, sm: 4 },
    }}
  >
    {/* Name */}
    <Typography fontSize={13} mb={0.5}>
      Name *
    </Typography>
    <input
      name="name"
      value={formData.name}
      onChange={handleChange}
      placeholder="Enter your full name"
      style={inputStyle}
    />

    {/* Phone */}
    <Typography fontSize={13} mt={2} mb={0.5}>
      Phone Number *
    </Typography>
    <input
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      placeholder="+91 XXXXX XXXXX"
      maxLength={10}
      inputMode="numeric"
      style={inputStyle}
    />

    {/* Email */}
    <Typography fontSize={13} mt={2} mb={0.5}>
      Email *
    </Typography>
    <input
      name="email"
      value={formData.email}
      onChange={handleChange}
      placeholder="you@example.com"
      style={inputStyle}
    />

    {/* Message */}
    <Typography fontSize={13} mt={2} mb={0.5}>
      Message
    </Typography>
    <textarea
      name="message"
      value={formData.message}
      onChange={handleChange}
      placeholder="Tell us about your requirements"
      rows={4}
      style={{
        ...inputStyle,
        resize: "none",
      }}
    />

    <Button
      fullWidth
      variant="contained"
      onClick={handleSubmit}
      disabled={loading}
      sx={{
        mt: 3,
        bgcolor: "#0ea5e9",
        py: { xs: 1.1, md: 1.3 },
        fontWeight: 600,
        fontSize: { xs: 14, md: 15 },
        "&:hover": { bgcolor: "#0284c7" },
      }}
    >
      {loading ? "Submitting..." : "REGISTER AS VENDOR"}
    </Button>
  </Box>
</Box>



{/* ================= BOTTOM CTA ================= */}
<Box
  sx={{
    py: { xs: 5, md: 6 },
    px: { xs: 2, sm: 3 },
    bgcolor: "#16739e",
    textAlign: "center",
  }}
>
  <Typography
    variant="h5"
    fontWeight="700"
    sx={{
      color: "white",
      mb: 1,
      fontSize: { xs: "1.4rem", md: "1.6rem" },
    }}
  >
    Ready to Reach 100,000+ Drone Owners?
  </Typography>

  <Typography
    sx={{
      color: "#ccfbf1",
      maxWidth: 600,
      mx: "auto",
      mb: { xs: 3, md: 3.5 },
      fontSize: { xs: 13, md: 14 },
      lineHeight: 1.6,
      px: { xs: 1, sm: 0 },
    }}
  >
    Start selling your parts today. Free to list. Pay only on sales. First order within 7 days on average.
  </Typography>

  <Button
    variant="outlined"
    sx={{
      color: "white",
      borderColor: "white",
      px: { xs: 3.5, md: 4 },
      py: { xs: 1, md: 1.1 },
      fontSize: { xs: 13, md: 14 },
      fontWeight: 600,
      borderRadius: 1.5,
      "&:hover": {
        bgcolor: "rgba(255,255,255,0.12)",
        borderColor: "white",
      },
    }}
  >
    ENLIST YOUR DRONE
  </Button>
</Box>



    </>
  );
};

export default VendorLanding;
